import { createContext, PropsWithChildren, useContext } from "react";

export type CascadiaTheme = "light" | "dark" | "system";

export interface Themes {
  theme: CascadiaTheme;
  setTheme: (theme: CascadiaTheme) => void;
}

export const ThemeContext = createContext<Themes>({
  theme: "system",
  setTheme() {
    console.warn(
      "Attempted to change the theme but couldn't find a ThemeContext.Provider."
    );
  },
});

export function ThemeOverride(props: Partial<Themes> & PropsWithChildren) {
  const { theme, setTheme } = useContext(ThemeContext);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, ...props }}>
      {props.children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
